import { DataType } from "../../../../tables"
import { O, SpinnerDiv } from "../.."
import { useStateHooks } from "../../../../state"
import { getRouteFromTableName, RoutePath, useRoutesHooks } from "../../../routes"
import { useNavigate } from "react-router-dom"

type Props = {
    parentPath?: RoutePath
    children: JSX.Element
}

export const DetailWrapper = (props: Props) => {
    const { parentPath, children } = props

    const { parseUrl, getRoutePath } = useRoutesHooks()
    const { dataTypeId, tableName } = parseUrl()
  
    const { find } = useStateHooks()
    const navigate = useNavigate()
  
    const dataType = find(tableName!, dataTypeId) as O<DataType>
    const tableRoutePath = parentPath || getRouteFromTableName(tableName!)!
  
    if (!dataType) {
        setTimeout(() => navigate(getRoutePath(tableRoutePath)), 1000)
    }
  
    return dataType ? children : <SpinnerDiv />
}
